import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { useForm, useFormState } from 'react-final-form';
import { FilterLocations } from '../../../common/FilterLocations';
import { NewSearchCities } from '../../../NewSearchCities';
import { NewSearchLocations } from '../../../NewSearchLocations';
import { FiltersSection } from '../FiltersSection';
import {
  FilterLocationsWrapper,
  MainFiltersContainer,
  mainSectionStyles
} from './styled';
import useScreenSize from '../../../../../hooks/useScreenSize';
import { MainFiltersProps } from './types';
import { NewSearchLeasedFilters } from '../NewSearchLeasedFilters';
import { cityAndLocationsQuery } from '../../../../../api/queries';
import { CityAndLocationsQuery } from '../../../../../graphql/graphql';

export const MainFilters = ({
  setInitialCity,
  modalParams,
  setLocationsPopupIsOpen,
  hide,
  setCitiesPopupIsOpen,
  locationsPopupIsOpen,
  initialCity,
  citiesPopupIsOpen,
  renderSubmitText
}: MainFiltersProps) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();
  const client = useApolloClient();
  const { submit } = useForm();
  const renderProps = useFormState();
  const [locationsPopupWillOpen, setLocationsPopupWillOpen] = useState(false);
  const screen = modalParams?.initialScreen;

  const getCityLocations = async (cityId?: string) => {
    const locationsQueryVariables = {
      cityId,
      scope: 'ALL',
      limit: 1000
    };

    try {
      const { data }: { data: CityAndLocationsQuery } = await client.query({
        query: cityAndLocationsQuery,
        variables: locationsQueryVariables
      });

      return data?.locations;
    } catch (error) {
      console.error(error);
    }
  };

  const closeCitiesHandler = async (wasChanged = true, cityId?: string) => {
    if (wasChanged) {
      setInitialCity(cityId);

      const locations = await getCityLocations(cityId);

      if (locations?.length > 0) {
        setLocationsPopupIsOpen(true);
      }

      if (!locations?.length && (screen === 'locations' || screen === 'city')) {
        hide();
        setCitiesPopupIsOpen(false);
        submit();
      }

      if (locationsPopupWillOpen) {
        setLocationsPopupIsOpen(true);
        setLocationsPopupWillOpen(false);
      }
    }

    if (!wasChanged && screen !== 'filters') {
      hide();
    }

    setCitiesPopupIsOpen(false);
  };

  const openCitiesHandler = (event?: React.MouseEvent<HTMLDivElement>) => {
    event?.stopPropagation();
    if (
      screen === 'locations' ||
      screen === 'filters' ||
      (locationsPopupIsOpen && screen === 'city')
    ) {
      setLocationsPopupIsOpen(false);
    }

    setCitiesPopupIsOpen(true);
  };

  const toggleHandlerLocations = async () => {
    const locations = await getCityLocations(renderProps.values.city_id);

    if (screen === 'locations' || screen === 'city') {
      hide();
    }
    if (screen === 'filters') {
      setCitiesPopupIsOpen(false);
    }
    if (locations?.length > 0) {
      setLocationsPopupIsOpen(!locationsPopupIsOpen);
    } else {
      setCitiesPopupIsOpen(true);
    }
  };

  return (
    <MainFiltersContainer>
      <FiltersSection
        title={isSmall ? '' : t('search.locations_search.title')}
        styles={mainSectionStyles}
      >
        <FilterLocationsWrapper>
          <FilterLocations
            handleOpenLocations={toggleHandlerLocations}
            modalScreen={screen}
          />
        </FilterLocationsWrapper>
      </FiltersSection>

      <NewSearchCities
        citiesPopupIsOpen={citiesPopupIsOpen}
        closeCitiesHandler={closeCitiesHandler}
      />
      <NewSearchLocations
        modalParams={modalParams}
        formValues={renderProps.values}
        locationsPopupIsOpen={locationsPopupIsOpen}
        toggleHandlerLocations={toggleHandlerLocations}
        openCitiesHandler={openCitiesHandler}
        isInitialScreen={screen === 'locations'}
        renderSubmitText={renderSubmitText}
      />
      <FiltersSection
        title={isSmall ? '' : t('search.filters.dealType')}
        styles={mainSectionStyles}
      >
        <NewSearchLeasedFilters value={renderProps.values?.leased} />
      </FiltersSection>
    </MainFiltersContainer>
  );
};
